import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import React from 'react';
import QRCode from 'react-qr-code';


function QrCodeAluno({show, setShow, handleShow, handleClose, idAluno, nomeAluno}) {
 

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Qr Code do Aluno</Modal.Title>
        </Modal.Header>
        <Modal.Body><div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h3>{nomeAluno}</h3>
      <QRCode 
        value={idAluno} 
        size={256}
        bgColor="#ffffff"
        fgColor="#000000"
      />
    </div></Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default QrCodeAluno;